export { DocumentReport as default } from './DocumentReport';
